//CRN_20251218 - ⚠️ ngOnInit() called for components/directives & not services ⚠️

import { catchError, map, Observable, of, switchMap, tap, throwError } from 'rxjs';
import { ConfigSystemDTO } from 'src/app/core/models/system/config-system/config-system.dto';
import { DecryptAesClientSide } from 'src/app/core/encryption';
import { EncryptionService } from '../../general/encryption-service';
import { eSimApiPaths } from 'src/app/core/consts';
import { environment } from 'src/environments/environment';
import { ExceptionsService } from '../../general/exceptions-service';
import { HttpClientService } from '../../general/http-client-service';
import { Injectable } from '@angular/core';
import { StringResultDTO } from 'src/app/core/interfaces/general/string-result';

@Injectable({ providedIn: 'root' })

export class ConfigSystemService {
  
  // private curUser!             : SystemUserDTO;
  // private gridShowIdSystemAdmin: boolean=false;
  
  public allParamsAndValues: ConfigSystemDTO[] | undefined;
  public paramsLoaded      : boolean=false;

  constructor(
    private encryptionService: EncryptionService,
    private exceptionsService: ExceptionsService,
    private httpClientService: HttpClientService
  ) {
    try {
      
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  private encryptionConverter(configSystem: ConfigSystemDTO) {
    return {
             enteredBy  : DecryptAesClientSide(configSystem.enteredBy),
             enteredDate: configSystem.enteredDate,
             id         : configSystem.id,
             param      : DecryptAesClientSide(configSystem.param),
             value      : DecryptAesClientSide(configSystem.value)
           };
  }
      
  public getById(id: number): Observable<ConfigSystemDTO> {
    try {
      return this.encryptionService.encrypt_AesServerSideForWeb(<string><unknown>id, true)
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const idEncSS=encResult.result;
                            
                            return this.httpClientService.getById(environment.eSimApi +
                                                                  eSimApiPaths.ConfigSystem +
                                                                  "?idEncSS=" + idEncSS, undefined); 
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public getEncrypted(): Observable<ConfigSystemDTO[]> {
    try {
      return this.httpClientService.get<ConfigSystemDTO[]>(environment.eSimApi +
                                                           eSimApiPaths.ConfigSystem + "/" +
                                                           eSimApiPaths.ConfigSystemEncrypted)
      .pipe(
        map(x => x.map(this.encryptionConverter))
      );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public getEncryptedAny(): Observable<any> {
    try {
      return this.getEncrypted();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }
  
  public getValue(param: string, defaultValue: string="", valueToUpper: boolean=false): string {
    try {
      //#region SystemAdmin
            
      // this.curUser=this.authenticationService.currentUserObject();
      
      // if (this.curUser               != undefined &&
      //     this.curUser.systemAdmin   != undefined &&
      //     this.curUser.systemAdmin                &&
      //     this.gridShowIdSystemAdmin              &&
      //     (
      //       param==ConfigSystemParams.GridCompaniesShowId      ||
      //       param==ConfigSystemParams.GridShowId               ||
      //       param==ConfigSystemParams.GridUsersAssociateShowId ||
      //       param==ConfigSystemParams.GridUsersEsimShowId      ||
      //       param==ConfigSystemParams.GridUsersPortalShowId
      //     )
      //    ) {
      //     return "TRUE";
      // }

      //#endregion

      let configSystem: ConfigSystemDTO | undefined=this.allParamsAndValues?.find(x => x.param==param);

      if (configSystem==undefined || configSystem.value==undefined || configSystem.value=="") {
        return defaultValue;
      }
      
      if (valueToUpper) {
        return configSystem.value.toUpperCase();
      }

      return configSystem.value;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return defaultValue;
    }
  }

  public getValueAsBoolean(param: string, defaultValue: boolean=false): boolean {
    try {
      return this.getValue(param, defaultValue.toString().toUpperCase(), true)=="TRUE";
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return defaultValue;
    }
  }

  public getValueAsInteger(param: string, defaultValue: number=0): number {
    try {
      const valueStr=this.getValue(param, defaultValue.toString());
      const valueInt=parseInt(valueStr, 10);
  
      if (isNaN(valueInt)) {
        return defaultValue;
      }
  
      return valueInt;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return defaultValue;
    }
  }
  
public refreshConfigSystemValues(): Observable<void> {
  try {
    if (!this.paramsLoaded) {
      return this.getEncrypted()
                 .pipe(
                   tap({
                     next: data => {
                       this.allParamsAndValues=data;
                       this.paramsLoaded      =true;

                       //#region Params used within this service

                      //  let configSystem: ConfigSystemDTO | undefined=this.allParamsAndValues?.find(x => x.param==ConfigSystemParams.GridShowIdSystemAdmin);

                      //  this.gridShowIdSystemAdmin=(configSystem!=undefined && configSystem.value!=undefined && configSystem.value.toUpperCase()=="TRUE");
                       
                       //#endregion
                     },
                     error: (error) => {
                       throw new Error(this.exceptionsService.formatHttpError(error));
                     }
                   }),
                   map(() => void 0),
                   catchError((error) => {
                     this.exceptionsService.handleException(new Error(error));
                     return throwError(() => new Error(error));
                   })
                 );
    }
    
    return of(void 0);
  }
  catch(e) {
    this.exceptionsService.handleException(<Error>e);
    return throwError(() => e);
  }
}

  public setValue(param: string, value: string) {
    try {
      //JSON.stringify(configSystem)
      let configSystem: ConfigSystemDTO | undefined=this.allParamsAndValues?.find(x => x.param==param);
      
      if (configSystem==undefined)
        throw new Error(`ConfigSystemService.setValue() The param cannot be found (${param})`);

      configSystem.value=value;

      return this.encryptionService.encrypt_AesServerSideForWeb(JSON.stringify(configSystem))
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const objectEnc=encResult.result;
                            
                            return this.httpClientService.put(environment.eSimApi +
                                                              eSimApiPaths.ConfigSystem +
                                                              "?id=" + configSystem.id +
                                                              "&objectEnc=" + objectEnc, undefined, {}); 
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }
}
